import { AlertTriangle, Zap, Clock, Heart, Brain, Shield, Users, FileText } from "lucide-react";

const ProblemSolutionSection = () => {
  const problems = [
    { icon: Clock, text: "Providers overwhelmed by documentation" },
    { icon: FileText, text: "Clerical overload causes burnout" },
    { icon: Heart, text: "Less time for patient care" },
  ];

  const solutions = [
    { icon: Users, text: "Outsourced medical documentation" },
    { icon: Brain, text: "Real-time scribes + AI refinement" },
    { icon: Shield, text: "Secure, compliant workflows" },
  ];

  return (
    <section 
      data-testid="problem-solution-section"
      className="py-16 sm:py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-xs sm:text-sm font-medium uppercase tracking-widest text-cyan-500 mb-3 sm:mb-4 block">
            The Challenge & Our Answer
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white">
            Problem vs Solution
          </h2>
        </div>

        {/* Comparison Grid */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-12">
          {/* Problem Card */}
          <div className="glass-card p-6 sm:p-8 md:p-10 problem-card">
            <div className="flex items-center gap-3 mb-6 sm:mb-8">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center">
                <AlertTriangle className="w-5 h-5 sm:w-6 sm:h-6 text-red-500" />
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold text-white">The Problem</h3>
            </div>
            <ul className="space-y-4 sm:space-y-6">
              {problems.map((item, index) => (
                <li 
                  key={index}
                  className="flex items-start gap-3 sm:gap-4"
                >
                  <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-red-500/5 border border-red-500/10 flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-4 h-4 sm:w-5 sm:h-5 text-red-400" />
                  </div>
                  <span className="text-slate-300 text-base sm:text-lg pt-1 sm:pt-2">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Solution Card */}
          <div className="glass-card p-6 sm:p-8 md:p-10 solution-card">
            <div className="flex items-center gap-3 mb-6 sm:mb-8">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center">
                <Zap className="w-5 h-5 sm:w-6 sm:h-6 text-cyan-500" />
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold text-white">Our Solution</h3>
            </div>
            <ul className="space-y-4 sm:space-y-6">
              {solutions.map((item, index) => (
                <li 
                  key={index}
                  className="flex items-start gap-3 sm:gap-4"
                >
                  <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-cyan-500/5 border border-cyan-500/10 flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-4 h-4 sm:w-5 sm:h-5 text-cyan-400" />
                  </div>
                  <span className="text-slate-300 text-base sm:text-lg pt-1 sm:pt-2">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolutionSection;
